export function validateCommentText(text) {
  if (!text) {
    return true;
  }

  if (text.length > 1000) {
    return 'Максимально допустимая длина комментария 1000 символов';
  }
}


// WEBPACK FOOTER //
// ./src/data/validator.js